import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import ComponenteService from '../../../../../services/componentes';


const Componente = () => {
    let { id } = useParams()
    const [nome, setNome] = useState("");
    const [categoria, setCategoria] = useState("");
    const [tipo, setTipo] = useState("");
    const [modeloReferencia, setModeloReferencia] = useState("");
    const [descricao, setDescricao] = useState("");
    const [especificacaoTecnica, setEspecificacaoTecnica] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);

    async function fetchComponentes(id) {
        const response = await ComponenteService.compEdit(id);
        setNome(response.data["nome"]);
        setCategoria(response.data["categoria"]);
        setTipo(response.data["tipo"]);
        setDescricao(response.data["descricao"]);
        setModeloReferencia(response.data["modeloReferencia"]);
        setEspecificacaoTecnica(response.data["especificacaoTecnica"]);
    }

    useEffect(() => {
        fetchComponentes(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const comp = await ComponenteService.editar(id, {
                nome: nome,
                categoria: categoria,
                tipo: tipo,
                modeloReferencia: modeloReferencia,
                descricao: descricao,
                especificacaoTecnica: especificacaoTecnica
            })
            if (comp.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 3 segundos
    }

    // Quando redirect virar true → redireciona
    if (redirect) {
        return <Navigate to="/ti/componentes/listar" />;
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={12}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={12} lg={3}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group controlId="selectCategoria">
                                        <Form.Label>Categoria</Form.Label>
                                        <Form.Select required onChange={e => setCategoria(e.target.value)}>
                                            <option value={categoria}>{categoria}</option>
                                            <option value="Computador">Computador</option>
                                            <option value="Notebook">Notebook</option>
                                            <option value="Teclado">Teclado</option>
                                            <option value="Mouse">Mouse</option>
                                            <option value="Monitor">Monitor</option>
                                            <option value="Processador">Processador</option>
                                            <option value="Memória RAM">Memória RAM</option>
                                            <option value="HD/SSD">HD/SSD</option>
                                            <option value="Placa-mãe">Placa-mãe</option>
                                            <option value="Fonte">Fonte</option>
                                            <option value="Gabinete">Gabinete</option>
                                            <option value="Impressora">Impressora</option>
                                            <option value="No-break">No-break</option>
                                            <option value="Multifuncional">Multifuncional</option>
                                            <option value="Toner">Toner</option>
                                            <option value="Gabinete">Gabinete</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group controlId="selectTipo">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Select required value={tipo} onChange={e => setTipo(e.target.value)}>
                                            <option value={tipo}>{tipo}</option>
                                            <option value="Permanente">Permanente</option>
                                            <option value="Consumo">Consumo</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="descricao">
                                        <Form.Label>Descrição curta para leigos</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="descricao"
                                            value={descricao}
                                            onChange={e => setDescricao(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="modeloReferencia">
                                        <Form.Label>Modelo de referência</Form.Label>
                                        <Form.Control
                                            required
                                            as="textarea"
                                            rows={6}
                                            name="modeloReferencia"
                                            value={modeloReferencia}
                                            onChange={e => setModeloReferencia(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="especificacaoTecnica">
                                        <Form.Label>Especificação Técnica</Form.Label>
                                        <Form.Control
                                            required
                                            as="textarea"
                                            rows={20}
                                            name="especificacaoTecnica"
                                            value={especificacaoTecnica}
                                            onChange={e => setEspecificacaoTecnica(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                            </Row>
                            <Row>
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/ti/componentes/listar'}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Componente editado com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default Componente;